import Decimal from "decimal.js";

Decimal.set({ precision: 50 });

interface ConversionOptions {
  amount: number;
  rate: number;
  fromDisplayRate: number;
  toDisplayRate: number;
}

export const convertAmount = ({
  amount,
  rate,
  fromDisplayRate,
  toDisplayRate,
}: ConversionOptions): Decimal => {
  const dataAmount = new Decimal(amount);
  const dataRate = new Decimal(rate);

  if (fromDisplayRate === 1 || toDisplayRate === 1) {
    return dataAmount.div(dataRate);
  }

  return dataAmount.mul(dataRate);
};
